module.exports = __webpack_public_path__ + "static/media/kitchen_paper_thumbnail.4f9ab4a8.png";